module.exports = __webpack_public_path__ + "static/front/img/banner-3.c560438b.jpg";